import { useEffect, useState } from "react";
import { getPipelineList, getStageListByPipeline } from "../../../addContact/contactApi";


const useGetPipelineAndStage = (selectedPipelineId) => {
  const [pipelineList, setPipelineList] = useState([]);
  const [stages, setStages] = useState([]);

  const [isLoadingPipelines, setIsLoadingPipelines] = useState(false);
  const [isLoadingStages, setIsLoadingStages] = useState(false);

  useEffect(() => {
    const fetchPipelines = async () => {
      setIsLoadingPipelines(true);
      try {
        const response = await getPipelineList();
        if (response.status === 200 && response.data?.data?.length > 0) {
          setPipelineList(response.data.data);
        }
      } catch (err) {
        console.error("Error fetching pipelines:", err);
      } finally {
        setIsLoadingPipelines(false);
      }
    };

    fetchPipelines();
  }, []);

  useEffect(() => {
    if (!selectedPipelineId) {
      setStages([]);
      return;
    }

    const fetchStages = async () => {
      setIsLoadingStages(true);
      try {
        const response = await getStageListByPipeline({ pipelineId: selectedPipelineId });
        if (response.status === 200 && response.data?.dealStage?.length > 0) {
          setStages(response.data.dealStage);
        }
      } catch (err) {
        console.error("Error fetching stages:", err);
      } finally {
        setIsLoadingStages(false);
      }
    };

    fetchStages();
  }, [selectedPipelineId]);

  return {
    pipelineList,
    stages,
    isLoadingPipelines,
    isLoadingStages,
  };
};

export default useGetPipelineAndStage;
